<template>
    <div :class="settings.classes != undefined ? settings.classes : ''">
        
        <div v-for="(field, key) in fields" :key="key" :class="field.attributes.columns != undefined ? field.attributes.columns : ''">
            <template v-if="field.type == 'button'">
                <button :name="key" v-if="field.attributes.action != undefined && field.attributes.action == 'ajax'" :class="field.attributes.classes != undefined ? field.attributes.classes : ''" :disabled="(locked != undefined && locked) || (Object.keys(errors).length > 0) || loadingUpload ? true : false" type="button" @click.prevent="executeAjax(field.attributes)">
                    {{ field.attributes.value }}
                </button>
            </template>
            <template v-else>
                <label v-if="field.attributes.label != undefined && (field.attributes.showLabel == undefined || field.attributes.showLabel)" :class="field.attributes.labelClasses != undefined ? field.attributes.labelClasses : ''" :for="key" v-html="field.attributes.label"></label>

                <div :class="'input-group' + (field.attributes.inputGroupClasses != undefined ? ' ' + field.attributes.inputGroupClasses: '')">
                    <div v-if="field.attributes.icon != undefined || field.attributes.img != undefined" class="input-group-prepend">
                        <div class="input-group-text">
                            <img v-if="field.attributes.img != undefined" :src="field.attributes.img">
                            <i v-if="field.attributes.icon != undefined" :class="field.attributes.icon"></i>
                        </div>                    
                    </div>

                    <vue-input v-if="field.type == 'input'" :id="key" :key="key" :attributes="field.attributes" :reset="reset" :locked="locked" @changed="changed"></vue-input>

                    <div v-if="errors[key] != undefined" class="invalid-feedback" v-html="errors[key].message"></div>
                </div>
            </template>
        </div>
        <overlay v-if="settings.overlay == undefined || settings.overlay" :enabled="forceLoading != false ? forceLoading :loading"></overlay>
    </div>
</template>

<script>
    import VueInput from './Fields/Input.vue';
    import Overlay from './Overlay.vue';

    import validator from '../mixins/validator';
    import notificator from '../mixins/notificator';

    export default {
        components: {VueInput, Overlay},

        props: ['form'],

        mixins: [validator, notificator],

        data() {
            return {
                settings: {},
                fields: {},
                items: {}, //create | update   
                loading: false,
                forceLoading: false,
                loadingUpload: false,
                ready: false,
                reset: null,
                locked: false,
                notifications: {
                    live: {
                        flash: false,
                        fields: true
                    },
                    submit: {
                        flash: false,
                        fields: true
                    }
                },
            }
        },

        created() {
            this.settings = this.form.settings;
            this.fields = this.form.fields;            
        },

        mounted() {
            this.ready = true;
        },

        methods: {
            changed(changed) {
                var changedId = null;
                if(this.fields[changed.id] != undefined && this.fields[changed.id]['type'] == 'select' && this.fields[changed.id]['settings'] != undefined && this.fields[changed.id]['settings']['options'] != undefined && this.fields[changed.id]['settings']['options']['id'] != undefined)
                    changedId = this.fields[changed.id]['settings']['options']['id'];
                else
                    changedId = changed.id;

                if(this.fields[changedId] != undefined && this.ready && changed.refresh == undefined) {
                    if(this.fields[changedId]['attributes']['confirmationField'])
                        this.validateField(changedId, this.fields[changed.id], changed.value, this.notifications.live.flash, this.notifications.live.fields, this.items[this.fields[changedId]['attributes']['confirmationField']]);
                    else
                        this.validateField(changedId, this.fields[changed.id], changed.value, this.notifications.live.flash, this.notifications.live.fields);
                }

                if(changed.value != null && changed.value != '') {
                    if(this.fields[changed.id] != undefined && this.fields[changed.id]['type'] == 'select' && typeof changed.value == 'object' && changed.value['id'] != undefined) {
                        this.$set(this.items, changedId, changed.value['id']);
                        
                        if(this.settings.calculateFields != undefined && this.settings.calculateFields['fields'][changedId] != undefined) {
                            this.$set(this.calculateItems, changedId, changed.value['id']);
                        }

                    } else {
                        this.$set(this.items, changedId, changed.value);
                        
                        if(this.fields[changed.id] != undefined &&  this.fields[changedId]['attributes']['childs'] != undefined && Object.keys(this.fields[changedId]['attributes']['childs']).length  > 0 && this.errors[changedId] == undefined) {
                            for (let key in this.fields[changedId]['attributes']['childs']) {
                                this.getChildValue(key, this.fields[changedId]['attributes']['childs'][key]['source']);
                            }                            
                        }
                        
                        if(this.settings.calculateFields != undefined && this.settings.calculateFields['fields'][changedId] != undefined) {
                            this.$set(this.calculateItems, changedId, changed.value);
                        }
                    }
                }else {
                    this.$delete(this.items, changedId);

                    if(this.fields[changedId]['attributes']['childs'] != undefined && Object.keys(this.fields[changedId]['attributes']['childs']).length  > 0) {
                        for (let key in this.fields[changedId]['attributes']['childs']) {
                                this.$delete(this.items, key);
                        }                                             
                }

                    if(this.settings.calculateFields != undefined && this.settings.calculateFields['fields'][changedId] != undefined) {
                        this.$delete(this.calculateItems, changedId);
                    }
                }

                if(this.settings.multiform != undefined && this.settings.multiform && this.settings.id != undefined)
                    this.$emit('multi-form-items', {id: this.settings.id, items: this.items});

                if(this.settings.calculateFields != undefined && Object.keys(this.calculateItems).length > 0 && this.settings.calculateFields['fields'][changedId] != undefined) {
                    this.calculateFields(this.settings.calculateFields);
                }
            },

            executeAjax(attributes) {
                //Verifico se ci sono upload in corso
                if(this.loadingUpload || this.loading)
                    return;   
                    
                if(!this.validateForm(this.fields, this.items, this.notifications.submit.flash, this.notifications.submit.fields)) return;

                //Setto la variabile loading
                this.overlay(true);
                
                if(attributes.callType == undefined || attributes.callType == 'axios') {
                    alert('chiamata axios da terminare');
                } else {
                    this.$store
                    .dispatch(attributes.endpoint, {
                        fields: this.items
                    })
                    .then(({data}) => {
                        this.overlay(false);
                        
                        if(attributes.callback != undefined) 
                            this.callback(attributes.callback, data);
                            
                        this.notify(this.$options.filters.notification({endpoint: attributes.url.name, code: 200}));
                    })
                    .catch(error => {
                        this.notify(this.$options.filters.notification({endpoint: attributes.url.name, code: error}));
                        
                        this.overlay(false);                      
                    });
                }
            },

            callback(actions, response) {
                for (let key in actions) {
                    switch (key) {
                        case 'overlay':
                            //Setto la variabile force loading
                            this.forceOverlay(true);
                        break;
                        case 'resetForm':
                            //Resetto il form
                            this.resetForm();
                        break;
                        case 'locked':
                            if(actions[key]['target'] == '___self___')
                                this.locked = actions[key]['value'];                            
                        break;
                        case 'redirect':
                            var link = actions[key].url;
                            for (let i = 0; i < actions[key].fields.length; i++)
                                link = link.replace('{' + actions[key].fields[i] + '}', response.response[actions[key].fields[i]]);

                            this.$router.push({ name: link });
                        break;
                        case 'setValue':
                            //Ciclo i valori da settare 
                            for (let i = 0; i < actions[key].length; i++) {
                                if(response.response[actions[key][i]] != undefined) {
                                    this.$set(this.items, actions[key][i], response.response[actions[key][i]]);
                                }
                            }
                        break;

                        default: break;
                    }
                }

            },
            
            overlay(action) {
                this.loading = action;
            },            
        }
    }

</script>